import { AjaxService, internalMessageBus, Cookies, EventsManager } from "../../externals";
import { SeamlessRequestService } from "../RequestService";
import { TokenProcessingGateway, TokenHandler, RequestGateway, TokenStream, LogoutSubscription, TokenLoginSubscription, CookiesStorage, TokenReader, RenewErrorHandler } from "../../common";
import { delay, getClock, makeTokenRequest } from "../../helpers";
import { PlatformJwtManager } from "../../PlatformJwtManager";
export const seamlessAuthContextFactory = (config) => {
    if (!config.operatorAuthTokenId) {
        throw new Error("Invalid operatorAuthTokenId");
    }
    const tokenReader = new TokenReader(config.siteID, getClock(config.timeControl, config.initialTime));
    const tokenStorage = new CookiesStorage(tokenReader, Cookies);
    const gateway = getGateway(config, tokenStorage, tokenReader);
    const platformJwtManager = new PlatformJwtManager(tokenStorage, config.userInfo, tokenReader, gateway);
    return {
        Gateway: gateway,
        PlatformJwtManager: platformJwtManager,
        Subscriptions: getSubscriptions(gateway, tokenStorage, tokenReader, config)
    };
};
const getGateway = (config, storage, tokenReader) => {
    const service = new SeamlessRequestService(config.apiUrl, config.operatorAuthTokenId, new AjaxService(), config.pageMethods, makeTokenRequest);
    const tokenHandler = new TokenHandler(storage, internalMessageBus);
    const errorHandler = new RenewErrorHandler(config.userInfo, new EventsManager());
    const tokenStream = new TokenStream(service, tokenHandler, tokenReader, errorHandler);
    const tokenProcessingGateway = new TokenProcessingGateway(tokenStream);
    return new RequestGateway(service, tokenProcessingGateway, storage, tokenReader, delay);
};
const getSubscriptions = (gateway, storage, tokenReader, config) => [
    new LogoutSubscription(config.userInfo, gateway, tokenReader),
    new TokenLoginSubscription(config.userInfo, gateway, storage, tokenReader, legacySeamlessTokenLogin)
];
export const legacySeamlessTokenLogin = (userInfo) => userInfo.loadUser();
//# sourceMappingURL=SeamlessAuthContextFactory.js.map